<template>
  <!-- SKELETON -->
  <div v-if="loading" class="relative rounded-2xl overflow-hidden h-[300px] bg-grey-light-200">
    <Skeleton class="absolute inset-0 w-full h-full" />
  </div>

  <!-- REAL CARD -->
  <div v-else-if="id" class="relative rounded-2xl overflow-hidden h-[300px]">
    <a
      :href="ensureHttps(domain)"
      @click.prevent="handleClick(domain)"
      target="_blank"
      class="absolute inset-0 block"
    >
      <!-- Background image -->
      <img :src="logo" :alt="name" class="w-full h-full object-cover object-center" loading="lazy" />
      <!-- Overlay -->
      <div class="absolute inset-0 bg-black/20" />

      <!-- Content -->
      <div class="absolute inset-0 flex flex-col max-md:p-6 md:p-8">
        <!-- Name + New badge -->
        <div class="flex items-center gap-3 max-md:order-2">
          <h2 class="text-white text-3xl font-bold">{{ name }}</h2>
          <span
            v-if="isNewStore(createdAt)"
            class="bg-blue-50 text-blue-700 text-xs font-medium px-3 py-0.5 rounded-full h-[26px] inline-flex items-center"
          >
            New
          </span>
        </div>

        <!-- Availability pill — sits above the bottom nav -->
        <div class="max-md:order-1 md:mt-15 max-md:mb-2 md:mb-14">
          <span
            v-if="availability"
            class="backdrop-blur-sm bg-white/20 border border-[#C8C8C8A6] text-white text-sm font-medium px-4 rounded-full h-[30px] md:h-[34px] inline-flex items-center"
          >
            {{ availability }}
          </span>
        </div>
      </div>
    </a>
  </div>
</template>

<script setup lang="ts">
import { Skeleton } from '@/components/ui/skeleton';
import { isNewStore } from '@/utils/stores';

defineProps<{
  id: string | undefined;
  name: string | undefined;
  logo: string | undefined;
  availability: string | undefined;
  createdAt: string | undefined;
  loading: boolean;
  domain: string | undefined;
}>();

const handleClick = (domain: string | undefined) => {
  window.open(ensureHttps(domain), '_blank');
};

const ensureHttps = (url: string | undefined): string => {
  if (!url) return '#';
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  return `https://${url}`;
};
</script>
